import { BannerHeading } from '../../global/typography';
import StyledButton from '../../components/Button/Button';
import { buttonVariant } from '../../types/buttonTypes';
import {
    StyledSection,
    StyledContainer,
    StyledHeading,
    StyledSubtitle,
    StyledParagraph,
    ButtonContainer,
    ContentContainer,
} from '../MigrationSection/styles';
import { BaseSection } from '../../components/BaseSection';
import { Box, BoxProps } from '@chakra-ui/react';

export interface ImageWithBoxSectionProps extends BoxProps {
    image: {
        url: string;
    };
    title?: string;
    boxSide: 'left' | 'right';
    subtitle?: string;
    children?: string | JSX.Element | JSX.Element;
    leftSection: JSX.Element;
    rightSection: JSX.Element;
    ctaButton?: {
        title: string;
        href: string;
        variant: buttonVariant;
    };
}

const ImageWithBoxSection: React.FC<ImageWithBoxSectionProps> = ({
    image,
    boxSide,
    title,
    subtitle,
    children,
    ctaButton,
    rightSection,
    leftSection,
    ...props
}) => {
    return (
        <Box {...props}>
            <StyledSection $imageUrl={image.url}>
                <Box
                    display={'flex'}
                    flexDir={'column'}
                    alignItems={'self-start'}
                    justifyContent={'flex-start'}
                    id="side_box_first"
                >
                    {boxSide === 'right' ? leftSection : rightSection}
                </Box>
                <StyledContainer $flex="column" $side={boxSide} className={`side_box_${boxSide}`}>
                    <ContentContainer>
                        {boxSide === 'left' ? leftSection : rightSection}
                    </ContentContainer>
                </StyledContainer>
            </StyledSection>
        </Box>
    );
};

export default ImageWithBoxSection;
